import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { CardItem } from "./Card";
import { ReactNode } from "react";
import { HTMLElement } from "../HTMLElement";
import Link from "../Link";

export function CardBody(card: CardItem): ReactNode {
    const { link, linkTitle } = card;

    function render() {
        const { image, altImageText, title, subtitle, content, html } = card;

        return <>
            <div className="card-image">
                {image ? <img src={image} alt={altImageText} /> : <></>}
            </div>
            {title ? <Card.Title>{title}</Card.Title> : <></>}
            {subtitle ? <Card.Subtitle>{subtitle}</Card.Subtitle> : <></>}
            <div className="card-text">{content}</div>
            {html ? <HTMLElement as={"div"} html={String(html)} config={{
                SANITIZE_DOM: false,
                FORCE_BODY: true,
                ADD_TAGS: ["script"],
                ADD_ATTR: ["async", "defer", "src"]
            }} className="card-html" /> : <></>}
        </>
    }

    return link ? (<Link href={link} title={linkTitle}>
        {render()}
    </Link>) : render();
}

export function CardBodyHorizontal(card: CardItem): ReactNode {
    const { link, linkTitle } = card;

    function render() {
        let { image, altImageText, title, subtitle, content, html } = card;

        return <Row>
            <Col>
                {image ? <img src={image} alt={altImageText} /> : <></>}
            </Col>
            <Col>
                {title ? <Card.Title><strong>{title}</strong></Card.Title> : <></>}
                {subtitle ? <Card.Subtitle>{subtitle}</Card.Subtitle> : <></>}
                <div className="card-text">{content}</div>
                {html ? <HTMLElement as={"div"} html={String(html)} config={{
                    SANITIZE_DOM: false,
                    FORCE_BODY: true,
                    ADD_TAGS: ["script"],
                    ADD_ATTR: ["async", "defer", "src"]
                }} className="card-html" /> : <></>}
            </Col>
        </Row>
    }

    return link ? (<Link href={link} title={linkTitle}>
        {render()}
    </Link>) : render();
}